<template>
  <div class="addon-product-container">
      <div class="product-image-container" :class="[(canAddMore == false && this.currentQty == 0) ? 'disabled' :'available',isCorporate ? 'corporate' : '']">
        <img v-if="mainBadge != null" src="https://cdn.shopify.com/s/files/1/1363/8433/files/diverse.svg?v=1683569569" class="main-badge"/>
        <span v-if="secondaryBadge != null && !isPride" class="secondary-badge">{{secondaryBadge}}</span>
        <img v-if="isPride" src="https://cdn.shopify.com/s/files/1/1363/8433/files/Pride_badge.svg?v=1717085583" class="pride-badge"/>
        <img  src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" @click="loadModal()" width="270" height="270" class="lazyload main-image" loading="lazy" :src="product | getProductImage" >
        <img @click="loadModal()" v-if="product.images.length > 1" :src="product.images[1].src" class="hover-image" />
        <div v-if="canAddMore == false && this.currentQty == 0" class="limit-alert">{{limitMessage}}</div>
      </div>
      <button :disabled="canAddMore == false" @click="updateProductQuantity(true)" v-show="currentQty == 0" class="happybox-button white border">{{ addCopy }}</button>
      <div :class="!canAddMore ? 'no-more' : ''" class="quantity-container" v-show="currentQty > 0">
          <button 
            @mousedown="startDecrement" 
            @mouseup="stopDecrement" 
            @mouseleave="stopDecrement"
            @touchstart="startDecrement" 
            @touchend="stopDecrement"
            @click.prevent="handleDecrementClick">-</button>
          <p v-if="!isEditing" @click="enableEditing">{{currentQty}} per box</p>
          <input
          v-else
            type="number"
            v-model="inputQty"
            @blur="addSpecificQty"
            @keyup.enter="addSpecificQty"
            ref="quantityInput"
          />
          <button 
            v-tooltip="{content: limitMessage, container: false}" 
            @mousedown="startIncrement" 
            @mouseup="stopIncrement" 
            @mouseleave="stopIncrement"
            @touchstart="startIncrement" 
            @touchend="stopIncrement"
            @click.prevent="handleIncrementClick">+</button>
      </div>
      <p class="product-title">{{product.title}}</p>
      <p v-if="valuePrice" class="cost">Value: {{ valuePrice.value_price | moneySaleFormat }}</p>
      <div class="product-price-container">
        <span v-if="hasComparePrice != null" class="discount-price">{{hasComparePrice | moneySaleFormat}}</span>
        <span class="price">{{productPrice | moneySaleFormat}}</span>
      </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    props: {
        product: Object,
        cartProducts: Array,
        maxCapacity: Number,
        currentCapacity: Number,
        boxQty: Number,
        productLimit: Number,
        addCopy: String
    },
    data() {
      return {
        isHovering: false,
        inputQty: 0,
        isEditing: false,
        incrementInterval: null,
        decrementInterval: null,
        isHoldingIncrement: false,
        isHoldingDecrement: false,
      }
    },
    computed:{
        ...mapGetters([
          'corpName',
          'currentBudget',
          'budget'
        ]),
        realLimit(){
          if(this.product.corporate){
            return 9999
          };

          return this.productLimit;
        },
        productPrice(){
          return this.product.variants.find(x => x.price != "").price
        },
        valuePrice(){
          return this.product.variants.find(x => x.value_price);
        },
        hasComparePrice(){
          return this.product.variants.find(x => x.price != "").compare_at_price
        },
        currentQty(){
          if(this.cartProducts){
            var product = this.cartProducts.find(x => x.id == this.product.id);
            if(product)
              return product.quantity
          }
          return 0
        },
        canAddMore(){
          if(this.maxCapacity < (this.currentCapacity + this.product.capacity))
            return false
          if((this.boxQty * (this.currentQty + 1)) > this.maxInventory)
            return false
          if(this.currentQty >= this.realLimit)
            return false
          if((parseFloat(this.product.variants[0].price) + this.currentBudget) > this.budget)
            return false

          return true
        },
        maxInventory(){
          return Math.max(...this.product.variants.map(x => x.inventory_quantity))
        },
        limitMessage(){
          if(this.maxCapacity < (this.currentCapacity + this.product.capacity))
            return 'Your Box is too full!';
          if((this.boxQty * (this.currentQty + 1)) > this.maxInventory)
            return 'Not enough inventory';
          if(this.currentQty >= this.realLimit)
            return 'Item limit per box'
          if((parseFloat(this.product.variants[0].price) + this.currentBudget) > this.budget)
            return 'Goes over budget'

          return ''
        },
        secondaryBadge(){
          //Check badges in the following order. 
          // Minimum: has qtymin tag
          // Almost gone: Invetory < 20
          // Best seller: has "Filter_Badges_Best Seller" tag
          // New: has been published for less that 60 days

          if(this.isCorporate){
            return `Inventory: ${this.product.variants.reduce((prev, current) => prev + current.inventory_quantity,0)}`
          } 
          let qtyMin = this.product.tags.find(x => x.includes("QTYMIN") && !x.includes("DEMAND")) 
          if(qtyMin){
            qtyMin = qtyMin.split("_");
            qtyMin = qtyMin[qtyMin.length - 1];

            return `Minimum: ${qtyMin}`;
          }

          var inventory = this.product.variants[0].inventory_quantity;
          if(inventory < 20)
            return "Less than 20";
      
          var badge = this.product.tags.find(y => y.includes("Filter_Badges"));
          if(badge){
              badge = badge.replace("Filter_","").split("_")
              return badge[1];
          }

          return null
        },
        mainBadge(){
          var tags =  this.product.tags.filter(y => y.includes("Tag_"));
          if(tags.length > 0){
            tags = tags.map((x) => {
              var currentTag = x.replace("Tag_","").replace("Tag_","");
              return currentTag;
            })

            return tags[0];
          }

          var ethos = this.product.tags.filter(y => y.includes("Filter_Ethos"));
          if(ethos.length > 0){
            ethos = ethos.map((x) => {
              var currentEthos = x.replace("Filter_","").split("_")
              return currentEthos[1]
            })

            return ethos[0];
          }

          return null
          
        },
        isPride(){
          let prideTag = this.product.tags.find(x => x.includes("Pride Donation"))
          if(prideTag){
            return true;
          }
          return false
        },
        isCorporate(){
          let prideTag = this.product.tags.find(x => x.includes(this.corpName))
          if(prideTag){
            return true;
          }
          return false
        },
        shouldHover(){
          if(this.canAddMore == false && this.currentQty > 0 && this.isHovering == true){
            return true;
          }
          return false;
        },
        hasVariants(){
          return this.product.variants.length > 1 && this.product.variants.every(x => !x.sku || (x.sku && !x.sku.toLowerCase().includes("ondemand")));
        },
        isCustom(){
          return this.product.tags.some(x => x.includes("Customizable"))
        },
        hasMinQty(){
          return this.product.tags.some(x => x.includes("QTYMIN"))
        },
        isOnDemand(){
          return this.product.variants.some(x => x.sku.toLowerCase().includes("ondemand"));
        },
        badgeExtraClass(){
          switch(this.mainBadge){
            case "Women Owned":
              return "pink";
            case "Small Biz":
              return "green"
            case "BIPOC Owned":
              return "yellow"
            case "Sustainable":
              return "dgreen"
            case "Admin Professionals Day":
              return "lyellow"
            default:
              return '';
          }
        },
        productMaxQty(){
          //Get max value posible in products, no more than the product limit per box
          var maxValues = [this.realLimit]
          //Get limit based on inventory * total boxes
          let inventoryQty = this.maxInventory
          maxValues.push(Math.floor( inventoryQty / this.boxQty));
          //Get limit based on currentCapacity
          let maxPerCapacity = Math.max(...[Math.floor((this.maxCapacity - this.currentCapacity) / this.product.capacity + this.currentQty),this.currentQty])
          maxValues.push(maxPerCapacity);
          return Math.min(...maxValues)
        },
    },
    methods:{
      isMobile() {
        return window.innerWidth < 768;
      },
      updateProductQuantity(increment){
        if(this.hasVariants || this.isCustom || this.hasMinQty){
          this.loadModal();
          return;
        }
        if(increment){
          if(this.canAddMore)
            this.$store.commit('updateSelectedAddonProductsNew',{product: this.product, quantity: (this.currentQty + 1)});
        }
        else{
          this.$store.commit('updateSelectedAddonProductsNew', {product: this.product,quantity: (this.currentQty - 1)});
        }
      },
      loadModal(){
        if(this.canAddMore || this.currentQty > 0)
          this.$emit("loadmodal", this.product);
      },
      dateDiffInDays(a, b) {
        const _MS_PER_DAY = 1000 * 60 * 60 * 24;
        // Discard the time and time-zone information.
        const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
        const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
        return Math.floor((utc2 - utc1) / _MS_PER_DAY);
      },
      setButtonHover(state){
        this.isHovering = state;
      },
      enableEditing() {
        this.isEditing = true;
        this.inputQty = this.currentQty;
        this.$nextTick(() => {
          this.$refs.quantityInput.focus(); // Automatically focus the input
        });
      },
      disableEditing() {
        this.isEditing = false;
      },
      addSpecificQty() {
        let updateQty = this.productMaxQty >= this.inputQty ? this.inputQty : this.productMaxQty;
        this.$store.commit('updateSelectedAddonProductsNew',{product: this.product, quantity: updateQty});
        this.disableEditing(); // Exit editing mode
      },
      startIncrement(e) {
        e.preventDefault();
        // Execute immediately for quick feedback
        this.updateProductQuantity(true);
        // Set flag to indicate we're holding
        this.isHoldingIncrement = true;
        // Start interval after a short delay to distinguish between click and hold
        setTimeout(() => {
          if (this.isHoldingIncrement) {
            this.incrementInterval = setInterval(() => {
              this.updateProductQuantity(true);
            }, 50); // Adjust speed as needed (50ms = ~20 times per second)
          }
        }, 300); // 300ms delay before starting continuous increment
      },
      stopIncrement() {
        this.isHoldingIncrement = false;
        if (this.incrementInterval) {
          clearInterval(this.incrementInterval);
          this.incrementInterval = null;
        }
      },
      handleIncrementClick(e) {
        // Prevent default to avoid double-firing
        e.preventDefault();
        // Only execute if this was a quick click (not a hold)
        if (!this.incrementInterval) {
          // Already executed in mousedown, so do nothing
          // Or if somehow it didn't fire, execute now
        }
      },
      startDecrement(e) {
        e.preventDefault();
        // Execute immediately for quick feedback
        this.updateProductQuantity(false);
        // Set flag to indicate we're holding
        this.isHoldingDecrement = true;
        // Start interval after a short delay to distinguish between click and hold
        setTimeout(() => {
          if (this.isHoldingDecrement) {
            this.decrementInterval = setInterval(() => {
              this.updateProductQuantity(false);
            }, 50); // Adjust speed as needed (50ms = ~20 times per second)
          }
        }, 300); // 300ms delay before starting continuous decrement
      },
      stopDecrement() {
        this.isHoldingDecrement = false;
        if (this.decrementInterval) {
          clearInterval(this.decrementInterval);
          this.decrementInterval = null;
        }
      },
      handleDecrementClick(e) {
        // Prevent default to avoid double-firing
        e.preventDefault();
        // Only execute if this was a quick click (not a hold)
        if (!this.decrementInterval) {
          // Already executed in mousedown, so do nothing
          // Or if somehow it didn't fire, execute now
        }
      },
    },
    beforeDestroy() {
      // Clean up intervals when component is destroyed
      this.stopIncrement();
      this.stopDecrement();
    },
}
</script>

<style scoped>
.addon-product-container{
  width: 100%;
}

.product-image-container{
  width: 100%;
  position: relative;
  overflow: hidden;
  display: flex;
  margin-bottom: 0.5rem;
}

.product-image-container.corporate .main-image,.product-image-container.corporate .hover-image{
  object-fit: contain;
}

.product-image-container .main-image {
  width: 100%;
  background-color: #F6F6F6;
  cursor: pointer;
  height: 100%;
  aspect-ratio: 1;
  object-fit: cover;
}

.product-image-container .hover-image{
  background-color: #f6f6f6;
  width: 100%;
  height: 100%;
  object-fit: contain;
  cursor: pointer;
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  -webkit-transition: all .35s ease-in-out;
  transition: all .35s ease-in-out;
  opacity: 0;
}

.product-image-container:hover .hover-image{
  opacity: 1;
}

.product-image-container.disabled img{
  opacity: 0.4;
}

.limit-alert{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 10px;
  background-color: white;
  width: 100%;
  position: absolute;
  bottom: 40%;
  font-size: 1.2vw;
  color: black;
  font-weight: bold;
}

.happybox-button{
  width: 100%;
}

.product-image-container.available:hover .happybox-button{
  bottom: 5%;
  z-index: 1;
}

.quantity-container{
  width: 100%;
  display: flex;
  align-items: stretch;
  justify-content: space-around;
  z-index: 2;
}

.quantity-container button{
  display: flex;
  font-size: 2vw;
  width: 15%;
  line-height: 1.15;
  justify-content: center;
  align-items: center;
  background-color: white;
  border: 1px solid #F3EEFA;
  box-shadow: 0px 1px 2px #1f293714;
  border-radius: 4px;
}

.quantity-container button:hover{
  background-color: #faf7fe
}

.quantity-container button.has-tooltip{
  opacity: 0.6;
}

.quantity-container p{
  background: #FFFFFF;
  border: 1px solid #F3EEFA;
  border-radius: 4px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 1%;
  width: 50%;
  font-size: 1vw;
}

.quantity-container input{
  height: unset;
  width: 50%;
}

.product-title{
  font-weight: 700;
  font-size: 1.1vw;
  line-height: 1.5;
  margin-top: 2%;
}

.cost{
  font-size: 1.1vw;
  line-height: 1.5;
}

.product-price-container{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  font-size: 1vw;
  line-height: 1.43;
  padding-bottom: 5%;
}

.product-price-container .price{
  color: #3F3D60;
}

.product-price-container .discount-price{
  color: red;
  text-decoration: line-through;
  padding-right: 5%;
}

.main-badge{
  position: absolute;
  top: 2%;
  left: 2%;
  padding: 1% 3%;
  width: 35%;
}

.pride-badge{
  position: absolute;
  bottom: 3%;
  right: 3%;
  width: 75%;
}

.secondary-badge{
  background-color: white;
  position: absolute;
  top: 2%;
  left: 2%;
  border: 1px solid #F3EEFA;
  box-sizing: border-box;
  border-radius: 4px;
  padding: 1% 3%;
  font-size: 1.1vw;
  font-weight: bold;
  color: #5981d9;
}

.main-badge.pink{
  background-color: #fbdaff;
}

.main-badge.green{
  background-color: #d8efdf;
}

.main-badge.yellow{
  background-color: #ffe7c7;
}

.main-badge.dgreen{
  background-color: #a9ffbd;
}

.main-badge.lyellow{
  background-color: #fffcdd;
}

.secondary-badge{
  top: unset;
  left: unset;
  bottom: 2%;
  right: 2%;
  background-color: #eff4fe;
  z-index: 2;
}

@media screen and (min-width: 767px){
  .addon-product-container{
    display: flex;
    flex-direction: column;
    height: 100%;
  }
}


@media screen and (max-width: 767px){
  .happybox-button{
    position: initial;
    box-shadow: 0px 1px 2px rgba(31, 41, 55, 0.08);
    margin: 3% 0%;
    width: 100%;
    padding: 2%;
  }
  .quantity-container{
    position: relative;
    margin: 4% 0%;
  }
  .quantity-container button{
    font-size: 2rem;
    line-height: 1.51;
    color: #0F0C38;
    border-radius: 50px;
    height: 3.2rem;
    width: 3.2rem;
  }

  .quantity-container p{
    font-size: 1rem;
    color: #0F0C38;
    border: unset;
  }

  .product-title{
    font-size: 0.9rem;
  }

  .product-price-container{
    font-size: 1rem;
  }

  .main-badge{
    top: 2%;
    font-size: 0.8rem;
  }

  .secondary-badge{
    font-size: 1rem;
  }

  .limit-alert{
    font-size: 3.5vw;
  }

  .quantity-container button .tooltip{
    display: none;
  }

  .quantity-container .no-more .tooltip{
    display: inherit;
  }

  .cost{
    font-size: 3vw;
  }
}

</style>